import React, { useState } from 'react';

import { OneColumn } from 'components/page';
import { LocalFuncionarioGrid, LocalFuncionarioGridFilter, LocalFuncionarioImportModal } from 'pages/complementar/local-funcionario/components';

export function LocalFuncionarioListComp() {
    const [openImportModal, setOpenImportModal] = useState<boolean>(false);
    return (
        <OneColumn
            title="Locais de Funcionário"
            createButton
            extraButtons={[
                {
                    title: 'Importar',
                    onClick: () => setOpenImportModal(true),
                },
            ]}
        >
            <LocalFuncionarioImportModal open={openImportModal} setOpen={setOpenImportModal} />

            <LocalFuncionarioGridFilter />

            <LocalFuncionarioGrid />
        </OneColumn>
    );
}
